import * as React from "react";
import { List } from "./List";

export const useSearchInputForList = <TItem extends {}>() => {
    const [searchText, setSearchText] = React.useState("");
    const listRef = React.useRef<List<TItem>>(null);
    const onSearchInputKeyDown = React.useCallback((e: React.KeyboardEvent) => {
        if (listRef.current) {
            listRef.current.onKeyDown(e);
        }
    }, []);

    return { listRef, onSearchInputKeyDown, searchText, setSearchText };
};
